module.exports = {
    fullName: function (user) {
        if (!user) {
            return null;
        }
        let { firstName, middleName = '', lastName } = user;
        return `${lastName} ${firstName} ${middleName || ''}`.trim();
    },

    shortName: function (user) {
        if (!user) {
            return null;
        }
        let { firstName, middleName = '', lastName } = user;
        let components = [lastName];

        if (firstName) {
            if (firstName.length > 1) {
                components.push(firstName.charAt(0) + '.');
            } else {
                components.push(firstName);
            }
        }
        if (middleName) {
            if (middleName.length > 1) {
                components.push(middleName.charAt(0) + '.');
            } else {
                components.push(middleName);
            }
        }

        return components.join(' ');
    }
};



// WEBPACK FOOTER //
// ./helpers/formatter.js